export class TaskFeed {
  constructor(
    readonly taskIds: string[],
    readonly cursor?: string,
  ) {}
}
